import React from 'react';
import {
  ReactComponent as SearchIcon
} from '@pagerduty/design-system/dist/icons/search.svg';

const SearchBox = () => (
  <div className="nav-item search">
    <div className="search-wrapper">
      <form className="search-container" method="GET" action="/search">
        <div className="icon"><SearchIcon className="ionicon" /></div>
        <input type="text" autoComplete="off" id="global-search" name="searchString" placeholder="Search (beta)" />
      </form>
    </div>
  </div>
);

export default SearchBox;
